import { useMemo, useState, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as ConfirmIcon } from "../../assets/waiting-for-approval.svg";
import { isEmpty } from "lodash";

import "./editor.css";

//Components
import LawDetails from "../../components/editLaws/LawDetails";
import LawForm from "../../components/editLaws/LawForm";

import { Tooltip, IconButton } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { EditOutlined as Edit } from "@ant-design/icons";
import { ReactComponent as DeleteIcon } from "../../assets/bin.svg";

import { Button, Modal, Form, Input, DatePicker, Radio, Spin } from "antd";
import { format } from "date-fns";
import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";

//child table related imports
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import {
  createObligation,
  updateObligationMother,
  checkObligationEditability,
  deleteMotherObligation
} from "../../store/obligations/actions";
import { editObligationModal } from "../../store/forms/actions";
import {
  checkLawEditability,
  updateLaw,
  deleteLaw
} from "../../store/laws/actions";

dayjs.extend(utc);

const Editor = () => {
  const dispatchito = useDispatch();
  const user = useSelector(state => state.user);
  const obligations = useSelector(state => state.obligations.obligations);
  const organizationId = useSelector(
    state => state.organizations.organizationId
  );
  const laws = useSelector(state => state.laws.laws);
  const lawDocuments = useSelector(state => state.documents?.laws ?? {});
  const loading = useSelector(state => state.forms.loading);
  // const [count, setCount] = useState(false);
  const [deleted, setDeleted] = useState(false);

  // Additional loading state
  const [isDetailPanelLoading, setIsDetailPanelLoading] = useState(false);

  const [selectedDetail, setSelectedDetail] = useState(null);

  const [selectedLaw, setSelectedLaw] = useState({});
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedDocumentObligations, setSelectedDocumentObligations] =
    useState([]);
  const [selectedObligation, setSelectedObligation] = useState(null);

  //modal related
  const [isOpen, setIsOpen] = useState(false);

  // const isEditObligationModal = useSelector(state => state.forms.isEditObligationModal);
  const [isEditLawModal, setIsEditLawModal] = useState("");
  const [isEditObligationModal, setIsEditObligationModal] = useState("");

  const [form] = Form.useForm();
  //editForm is the destructured form object for law edit
  const [editForm] = Form.useForm(); // For "Edit Law" form
  const [editObligationForm] = Form.useForm(); // For "Edit Obligation" form
  const fileInputRef = useRef(null);
  const [isRecurring, setIsRecurring] = useState(false);
  // edit modal related
  const [validationErrors, setValidationErrors] = useState({});

  const { confirm, info } = Modal;
  const deleteConfirm = (item, statusCode) => {
    statusCode === 200
      ? confirm({
          title: "Delete Confirmation",
          icon: <ConfirmIcon />,
          content: (
            <div>
              <p>{`Are you sure you want to delete the obligation with description "${item.description}";`}</p>
              {item?.__v > 0 && (
                <p>
                  <strong>Attention:</strong> This obligation has been edited at
                  least once before.
                </p>
              )}
            </div>
          ),
          okText: "Confirm",
          cancelText: "Close",
          onOk() {
            handleDeleteRow(item);
          },
          onCancel() {
            console.debug("Κλείσιμο Modal");
            console.debug(item);
          }
        })
      : info({
          title: "Invalid Action",
          icon: <ConfirmIcon />,
          content: (
            <div>
              <p>Obligation with description:</p>
              <p>
                <strong>{`"${item.description}"`}</strong>
              </p>
              <p>
                cannot be deleted as one or more cloned obligations have already
                been updated.
              </p>
            </div>
          ),
          okText: "Close"
        });
  };

  const deleteConfirmLaw = (item, statusCode) => {
    statusCode === 200
      ? confirm({
          title: "Delete Confirmation",
          icon: <ConfirmIcon />,
          content: `Are you sure you want to delete law "${item?.title}" with description "${item?.description}"?`,
          okText: "Confirm",
          cancelText: "Close",
          onOk() {
            handleDeleteRowLaw(item);
            setDeleted(true);
          },
          onCancel() {
            console.debug("Κλείσιμο Modal");
            console.debug(item);
          }
        })
      : info({
          title: "Invalid Action",
          icon: <ConfirmIcon />,
          content: (
            <div>
              <p>
                Law <strong>{`"${item.description}"`}</strong> cannot be deleted
                as{" "}
                {item?.__v > 0
                  ? "it has already been edited"
                  : "one or more obligations have been updated"}
                .
              </p>
            </div>
          ),
          okText: "Close"
        });
  };

  const handleRecurringChange = e => {
    setIsRecurring(e.target.value === "Yes");
  };

  const [isLoading, setIsLoading] = useState(false);
  //create obligation
  const handleOk = () => {
    form.validateFields().then(values => {
      setIsOpen(false);
      setIsLoading(true);
      // window.location.reload(false);
      let formData = new FormData();
      // console.debug("inside submit handler values: ", values);
      // formData.append("title", values.title);
      formData.append("article", values.article);
      formData.append("paragraph", values.paragraph);
      formData.append("description", values.description);
      formData.append("info", values.info ? values.info : "");
      formData.append("dueDate", values.dueDate ? values.dueDate : "");
      formData.append("mainCategory", selectedDocument.mainCategory);
      formData.append("inForceDate", selectedDocument.inForceDate);
      formData.append("law_title", selectedDocument.title);

      formData.append("law_id", selectedDocument._id);

      dispatchito(
        createObligation({
          payload: formData,
          token: user.token,
          callback: () => {
            form.resetFields();
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            setIsLoading(false);
            // setCount(!count);
          }
        })
      );
    }).catch((err) => {});
  };

  //handle law edit
  const handleEdit = values => {
    editForm.validateFields().then(values => {
      let formData = new FormData();
      // console.debug("inside submit handler values: ", values);
      // formData.append("title", values.title);
      formData.append("_id", selectedDocument._id);
      formData.append("title", values.title);
      formData.append("description", values.description);
      let object = {};
      formData.forEach((value, key) => (object[key] = value));
      dispatchito(
        updateLaw(user, selectedDocument._id, organizationId, object)
      );
      setIsEditLawModal("");
    });
  };

  //handle obligation edit
  const handleObligationEdit = values => {
    editObligationForm.validateFields().then(values => {
      // setIsDetailPanelLoading(true);

      let formData = new FormData();
      // console.debug("inside handleObligationEdit handler values: ", values);
      formData.append("article", values.article);
      formData.append("paragraph", values.paragraph);
      formData.append("description", values.description);
      formData.append("dueDate", values.dueDate ? values.dueDate : "");
      formData.append("info", values.info ? values.info : "");
      const object = {};
      formData.forEach((value, key) => (object[key] = value));

      dispatchito(updateObligationMother(selectedObligation._id, object, user));
      setIsEditObligationModal("");
    });
  };

  //handle cancel for law edit - Edit Law
  const handleLawCancel = () => {
    dispatchito({ type: "CHECK_LAW_SUCCESS", payload: "" });
    // setIsOpen(false);
    form.resetFields();
    setIsEditLawModal("");
  };

  //handle cancel for law edit - Add Obligation
  const handleCancel = () => {
    setIsOpen(false);
    form.resetFields();
    setIsEditLawModal("");
  };

  //handle cancel for obligation edit
  const handleObligationEditCancel = () => {
    dispatchito(editObligationModal(false));
    setIsEditObligationModal("");
    editObligationForm.resetFields();
  };

  //validate related function
  const getCommonEditTextFieldProps = useCallback(
    cell => {
      return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onBlur: event => {
          const isValid =
            cell.column.id === "title"
              ? validateRequired(event.target.value)
              : cell.column.id === "description"
              ? validateRequired(event.target.value)
              : validateRequired(event.target.value);
          if (!isValid) {
            //set validation error for cell if invalid
            setValidationErrors({
              ...validationErrors,
              [cell.id]: `${cell.column.columnDef.header} is required`
            });
          } else {
            //remove validation error for cell if valid
            delete validationErrors[cell.id];
            setValidationErrors({
              ...validationErrors
            });
          }
        }
      };
    },
    [validationErrors]
  );

  //simple column definitions pointing to flat data
  const columns = useMemo(
    () => [
      {
        header: "Law Id",
        accessorKey: "_id", //simple accessorKey pointing to flat data
        enableEditing: false
      },
      {
        header: "Title",
        size: 50,
        enableColumnActions: false,
        enableColumnDragging: false,
        draggable: false,
        accessorKey: "title" //simple accessorKey pointing to flat data
        // muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
        //   ...getCommonEditTextFieldProps(cell)
        // })
      },
      {
        header: "Description",
        size: 400,
        enableColumnActions: false,
        enableColumnDragging: false,
        accessorKey: "description" //simple accessorKey pointing to flat data
        // muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
        //   ...getCommonEditTextFieldProps(cell)
        // })
      }
    ],
    [getCommonEditTextFieldProps]
  );

  const handleDeleteRow = row => {
    // console.debug("INSIDE handleDeleteRow - row: ", row);
    console.debug("handleDeleteRow");

    const parentId = row._id;
    dispatchito(deleteMotherObligation(parentId, user));
  };

  const handleDeleteRowLaw = row => {
    const law = row?._id;
    dispatchito(deleteLaw(user, law));
  };

  return (
    <div className="home-editor" id="home-editor-page">
      {loading || isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "755px",
            marginTop: "50px"
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div id="sidebar-law-form">
            <LawForm />{" "}
          </div>
          <div className="laws" id="home-editor-page-laws">
            {laws && (
              <>
                <MaterialReactTable
                  columns={columns}
                  displayColumnDefOptions={{
                    "mrt-row-actions": {
                      header: "", //change header text
                      size: 50 //small cell
                    },
                    "mrt-row-expand": {
                      header: "", //change header text
                      size: 50 //small cell
                    }
                  }}
                  data={laws ?? []}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10, 15]
                  }}
                  enablePagination={laws?.length > 5}
                  enableEditing
                  // onEditingRowSave={handleSaveRowEdits}
                  // onEditingRowCancel={handleCancelRowEdits}
                  enableExpandAll={false}
                  enableRowSelection={false}
                  enableMultiRowSelection={false}
                  enableColumnOrdering
                  enableGlobalFilter={false} //turn off a feature
                  enableRowActions
                  enableSorting
                  positionActionsColumn="last"
                  getSubRows={originalRow => {
                    return originalRow.subRows;
                  }}
                  getIsRowExpanded={row => {}}
                  getRowId={row => row._id}
                  // onRowSelectionChange={setSelectedLaw}
                  state={{ selectedLaw }}
                  initialState={{
                    columnVisibility: { _id: false },
                    pagination: { pageIndex: 0, pageSize: 5 },
                    expanded: false,
                    // sorting: [
                    //   {
                    //     id: "createdAt",
                    //     desc: true
                    //   }
                    // ]
                  }}
                  //clicking anywhere on the row will select it
                  muiTableBodyRowProps={({ row }) => ({
                    onClick: () => {
                      setSelectedLaw({ [row.id]: true });
                      // console.debug("row.id: ", row.id);
                      // console.debug(
                      //   "---->row.getIsExpanded(): ",
                      //   row.getIsExpanded()
                      // );
                      setSelectedDocument(row.original);
                      setSelectedDetail(row.id);
                    },
                    selected: selectedLaw[row.id],
                    sx: { cursor: "pointer" }
                  })}
                  renderRowActions={({ row, table }) => {
                    // Check if the user's organization id matches the law's organization id
                    return (
                      <div
                        className="editor-page-obligation-row"
                        id={`home-editor-page-obligation-row-${row?.id}`}
                      >
                        {/* <IconButton onClick={() => table.setEditingRow(row)}>
                          <Edit />
                        </IconButton> */}
                        {(user.organization === row.original.organization ||
                          user.organization === "") && (
                          <Button
                            id={`edit-law-button-${row.id}`}
                            style={{
                              borderColor: "#725798",
                              color: "#725798",
                              marginRight: "1.25rem"
                            }}
                            onClick={() => {
                              dispatchito(
                                checkLawEditability({
                                  user: user,
                                  id: row.id,
                                  action: "edit",
                                  callback: statusCode => {
                                    setIsEditLawModal(statusCode);
                                  }
                                })
                              );

                              setSelectedLaw({ [row.id]: true });
                              setSelectedDocument(row.original);
                              setSelectedDetail(row.id);
                              //the name of the law form is editForm
                              editForm.setFieldsValue({
                                title: row.original?.title,
                                description: row.original?.description
                              });
                            }}
                          >
                            Edit Law
                          </Button>
                        )}

                        {/* Return a disabled button for laws not created by the user */}
                        <Button
                          id={`add-obligation-button-${row.id}`}
                          style={{
                            borderColor: "#725798",
                            color: "#725798"
                          }}
                          disabled={
                            !(
                              user.organization === row.original.organization
                            ) && !(user.organization === "")
                          }
                          onClick={() => {
                            setIsOpen(true);
                            // console.debug("Add Obligation clicked!");
                            // console.debug("row id: ", row.id);
                          }}
                        >
                          Add Obligation
                        </Button>
                        <Tooltip
                          title="Delete"
                          style={{ marginLeft: "0.688rem" }}
                        >
                          <span
                            style={{
                              marginLeft: "0.688rem",
                              cursor:
                                !(
                                  user.organization ===
                                  row.original.organization
                                ) && !(user.organization === "")
                                  ? "not-allowed"
                                  : "pointer"
                            }}
                          >
                            <IconButton
                              aria-label="delete"
                              onClick={() => {
                                dispatchito(
                                  checkLawEditability({
                                    user: user,
                                    id: row.id,
                                    action: "delete",
                                    callback: statusCode => {
                                      deleteConfirmLaw(
                                        row.original,
                                        statusCode
                                      );
                                    }
                                  })
                                );
                              }}
                              disabled={
                                !(
                                  user.organization ===
                                  row.original.organization
                                ) && !(user.organization === "")
                              }
                            >
                              <DeleteIcon style={{ color: "#101828" }} />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </div>
                    );
                  }}
                  // renderRowActionMenuItems={({ closeMenu, row, table }) => {
                  //   return [
                  //     <MenuItem
                  //       key={0}
                  //       onClick={() => {
                  //         setIsOpen(true);
                  //         console.debug("Add Obligation clicked!");
                  //         console.debug("row id: ", row.id);
                  //         closeMenu();
                  //       }}
                  //       sx={{ m: 0 }}
                  //     >
                  //       <ListItemIcon>
                  //         <AddCircleIcon />
                  //       </ListItemIcon>
                  //       Add Obligation
                  //     </MenuItem>
                  //   ];
                  // }}
                  renderDetailPanel={({ row }) => {
                    let filteredObligationsId = obligations?.filter(
                      obl => row.id === obl.law_id
                    );

                    let filteredObligations;
                    if (user.role === "masterEditor") {
                      filteredObligations = filteredObligationsId?.filter(
                        obligation => !obligation.organization
                      );
                      if (filteredObligations) {
                        filteredObligations.sort((a, b) => {
                          const articleA = a.article.toUpperCase();
                          const articleB = b.article.toUpperCase();

                          if (articleA < articleB) {
                            return -1;
                          }
                          if (articleA > articleB) {
                            return 1;
                          }
                          if (articleA === articleB) {
                            const paragraphA = a.paragraph.toUpperCase();
                            const paragraphB = b.paragraph.toUpperCase();
                            if (paragraphA < paragraphB) {
                              return -1;
                            }
                            if (paragraphA > paragraphB) {
                              return 1;
                            }
                            return 0;
                          }
                          return 0;
                        });
                      }
                    } else if (user.role === "corporateEditor") {
                      filteredObligations = filteredObligationsId?.filter(
                        obligation =>
                          obligation.organization === user.organization ||
                          obligation._id === obligation.parent_id
                      );
                      if (filteredObligations) {
                        filteredObligations.sort((a, b) => {
                          const articleA = a.article.toUpperCase();
                          const articleB = b.article.toUpperCase();

                          if (articleA < articleB) {
                            return -1;
                          }
                          if (articleA > articleB) {
                            return 1;
                          }
                          if (articleA === articleB) {
                            const paragraphA = a.paragraph.toUpperCase();
                            const paragraphB = b.paragraph.toUpperCase();
                            if (paragraphA < paragraphB) {
                              return -1;
                            }
                            if (paragraphA > paragraphB) {
                              return 1;
                            }
                            return 0;
                          }
                          return 0;
                        });
                      }
                    }

                    return (
                      <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <TableCell>Article</TableCell>
                              <TableCell>Paragraph</TableCell>
                              {/* <TableCell>ApplyToAll</TableCell>
                          <TableCell>Company Size</TableCell> */}
                              <TableCell>Description</TableCell>
                              <TableCell>Due Date</TableCell>
                              <TableCell
                                colSpan={2}
                                style={{ textAlign: "left" }}
                              >
                                Actions
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {filteredObligations?.map(obligation => (
                              <TableRow
                                key={obligation._id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0
                                  }
                                }}
                              >
                                <TableCell component="th" scope="row">
                                  {obligation.article !== "undefined"
                                    ? obligation.article
                                    : "-"}
                                </TableCell>
                                <TableCell>
                                  {obligation.paragraph !== "undefined"
                                    ? obligation.paragraph
                                    : "-"}
                                </TableCell>
                                {/* <TableCell>
                              {obligation.applyToAll ? "Yes" : "No"}
                            </TableCell>
                            <TableCell>{obligation.size}</TableCell> */}
                                <TableCell>{obligation.description}</TableCell>
                                <TableCell>
                                  {obligation.dueDate
                                    ? format(
                                        new Date(obligation.dueDate),
                                        "dd MMM yyyy"
                                      )
                                    : "-"}
                                </TableCell>

                                <TableCell
                                  style={{
                                    cursor:
                                      isDetailPanelLoading ||
                                      (user.role === "corporateEditor" &&
                                        obligation._id !== obligation.parent_id)
                                        ? "not-allowed"
                                        : "pointer"
                                  }}
                                >
                                  <IconButton
                                    aria-label="edit"
                                    onClick={() => {
                                      dispatchito(
                                        checkObligationEditability({
                                          user: user,
                                          id: obligation._id,
                                          action: "edit",
                                          callback: statusCode => {
                                            setIsEditObligationModal(
                                              statusCode
                                            );
                                          }
                                        })
                                      );

                                      setSelectedObligation(obligation);
                                      editObligationForm.setFieldsValue({
                                        article: obligation.article,
                                        paragraph: obligation.paragraph,
                                        description: obligation.description,
                                        dueDate: obligation.dueDate
                                          ? dayjs.utc(obligation.dueDate)
                                          : ""
                                      });
                                    }}
                                    disabled={
                                      isDetailPanelLoading ||
                                      (user.role === "corporateEditor" &&
                                        obligation._id !== obligation.parent_id)
                                    }
                                  >
                                    <Edit
                                      style={{
                                        color: isDetailPanelLoading
                                          ? "#C0C0C0"
                                          : "#101828"
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                                <TableCell
                                  style={{
                                    cursor:
                                      isDetailPanelLoading ||
                                      (user.role === "corporateEditor" &&
                                        obligation._id !== obligation.parent_id)
                                        ? "not-allowed"
                                        : "pointer"
                                  }}
                                >
                                  <Tooltip title="Delete">
                                    <span>
                                      <IconButton
                                        aria-label="delete"
                                        onClick={() => {
                                          dispatchito(
                                            checkObligationEditability({
                                              user: user,
                                              id: obligation?._id,
                                              action: "delete",
                                              callback: statusCode => {
                                                deleteConfirm(
                                                  obligation,
                                                  statusCode
                                                );
                                              }
                                            })
                                          );
                                        }}
                                        disabled={
                                          user.role === "corporateEditor" &&
                                          obligation._id !==
                                            obligation.parent_id
                                        }
                                      >
                                        <DeleteIcon
                                          style={{ color: "#101828" }}
                                        />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ); //end of table container
                  }}
                />
                <Modal
                  id="modal1"
                  title="Add Obligation"
                  open={isOpen}
                  centered
                  width={580}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  okText="Create"
                  cancelButtonProps={{ id: "cancel-add-obligation" }}
                  okButtonProps={{ id: "ok-add-obligation" }}
                >
                  <Form
                    requiredMark={false}
                    id="form1"
                    form={form}
                    layout="vertical"
                  >
                    <Form.Item
                      label="Article"
                      name="article"
                      id="home-editor-page-form-1"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: "Please input the article!"
                      //   }
                      // ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item label="Paragraph" name="paragraph">
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label={
                        <span
                          className="custom-required-mark"
                          id="home-editor-page-custom-required-mark"
                        >
                          Description
                        </span>
                      }
                      name="description"
                      id="home-editor-page-form-2"
                      rules={[
                        {
                          required: true,
                          message: "Please input the obligation description!"
                        }
                      ]}
                    >
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item
                      label="Info"
                      name="info"
                      id="home-editor-page-form-2.5"
                    >
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item
                      label="Due Date"
                      id="home-editor-page-form-3"
                      name="dueDate"
                      rules={[
                        // {
                        //   required: true,
                        //   message: "Please input the due date!"
                        // },
                        //make sure due date is not before (or same as) law in-force date
                        () => ({
                          validator(rule, value) {
                            const inForce = selectedDocument.inForceDate.slice(
                              0,
                              10
                            ); //is ISO string and keep only date part
                            // console.debug(
                            //   "Inside add obligation, inForceDate:",
                            //   inForce
                            // );
                            const due = value
                              ? value.toISOString().slice(0, 10)
                              : "";
                            // console.debug("testing field rules for date:", due);
                            if (due && due < inForce) {
                              //setInvalidDueDate(true)
                              // console.debug(
                              //   "due date prior to in force: ",
                              //   due < inForce
                              // );
                              return Promise.reject([
                                "Due Date cannot be prior to In Force Date."
                              ]);
                            }

                            return Promise.resolve();
                          }
                        })
                      ]}
                    >
                      <DatePicker format="DD-MM-YYYY" />
                    </Form.Item>
                    <Form.Item
                      label={
                        <span
                          className="custom-required-mark"
                          id="home-editor-custom-required-mark-2"
                        >
                          Is Recurring
                        </span>
                      }
                      name="isRecurring"
                      id="home-editor-page-form-4"
                      rules={[
                        {
                          required: true,
                          message: "Please choose an option!"
                        }
                      ]}
                      initialValue="No" // Set default value to "No"
                    >
                      <Radio.Group
                        className="recurring-radio"
                        id="home-editor-recurring-radio"
                        onChange={handleRecurringChange}
                      >
                        <Radio value="Yes" id="recurring-yes">
                          Yes
                        </Radio>
                        <Radio value="No" id="recurring-no">
                          No
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                    {isRecurring && (
                      <Form.Item
                        label="Recurring Frequency (Months)"
                        id="home-editor-page-form-5"
                        name="recurringFrequency"
                        rules={[
                          {
                            required: true,
                            message:
                              "Please input the recurring frequency in months!"
                          }
                        ]}
                      >
                        <Input type="number" min="1" />
                      </Form.Item>
                    )}
                  </Form>
                </Modal>
                <Modal
                  id="modal2"
                  type="info"
                  title="Edit Law"
                  open={isEditLawModal}
                  onOk={handleEdit}
                  onCancel={handleLawCancel}
                  centered
                  wrapClassName={`edit-law-modal ${
                    isEditLawModal !== 200 ? "uneditable" : ""
                  }`}
                  okText="Save"
                  cancelButtonProps={{ id: "cancel-edit-law" }}
                  okButtonProps={{
                    id: "ok-edit-law",
                    disabled: isEditLawModal !== 200
                  }}
                >
                  {isEditLawModal === 200 ? (
                    <Form
                      requiredMark={false}
                      id="form2"
                      form={editForm}
                      layout="vertical"
                    >
                      <Form.Item
                        label={
                          <span
                            className="custom-required-mark"
                            id="home-editor-page-custom-required-mark-3"
                          >
                            Title
                          </span>
                        }
                        name="title"
                        rules={[
                          {
                            required: true,
                            message: "Please input title"
                          }
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label={
                          <span
                            className="custom-required-mark"
                            id="home-editor-page-custom-required-mark-4"
                          >
                            Description
                          </span>
                        }
                        id="home-editor-page-form-6"
                        name="description"
                        rules={[
                          {
                            required: true,
                            message: "Please input description"
                          }
                        ]}
                      >
                        <Input.TextArea rows={4} />
                      </Form.Item>
                    </Form>
                  ) : (
                    <p id="uneditable-law-message">
                      Law <strong>{`"${selectedDocument?.title}"`}</strong>{" "}
                      cannot be edited as one or more obligations have been
                      updated.
                    </p>
                  )}
                </Modal>
                <Modal
                  id="modal3"
                  type="info"
                  title="Edit Obligation"
                  open={isEditObligationModal}
                  onOk={handleObligationEdit}
                  onCancel={handleObligationEditCancel}
                  wrapClassName={`edit-obligation-modal ${
                    isEditObligationModal !== 200 ? "uneditable" : ""
                  }`}
                  centered
                  okText="Save"
                  cancelButtonProps={{ id: "cancel-edit-obl" }}
                  okButtonProps={{
                    id: "ok-edit-obl",
                    disabled: isEditObligationModal !== 200
                  }}
                >
                  {isEditObligationModal === 200 ? (
                    <Form
                      requiredMark={false}
                      id="form3"
                      form={editObligationForm}
                      layout="vertical"
                    >
                      <Form.Item
                        label="Article"
                        id="home-editor-page-form-7"
                        name="article"
                        rules={[
                          {
                            required: true,
                            message: "Enter article number..."
                          }
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Paragraph"
                        id="home-editor-page-form-8"
                        name="paragraph"
                        rules={[
                          {
                            required: true,
                            message: "Enter paragraph number..."
                          }
                        ]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label={
                          <span
                            className="custom-required-mark"
                            id="home-editor-page-custom-required-mark-3"
                          >
                            Description
                          </span>
                        }
                        name="description"
                        id="home-editor-page-form-9"
                        rules={[
                          {
                            required: true,
                            message: "Please input the obligation description!"
                          }
                        ]}
                      >
                        <Input.TextArea rows={4} />
                      </Form.Item>
                      <Form.Item
                        label="Info"
                        name="info"
                        id="home-editor-page-form-9.5"
                      >
                        <Input.TextArea rows={4} />
                      </Form.Item>
                      <Form.Item
                        label="Due Date"
                        name="dueDate"
                        id="home-editor-page-form-10"
                        rules={[
                          {
                            required: false,
                            message: "Enter a date..."
                          }
                        ]}
                      >
                        <DatePicker format="DD/MM/YYYY" />
                      </Form.Item>
                    </Form>
                  ) : (
                    <p id="uneditable-obligation-message">
                      Obligation with description:{" "}
                      <strong>{`"${selectedDocument?.description}"`}</strong>{" "}
                      cannot be edited as one or more cloned obligations have
                      already been updated.
                    </p>
                  )}
                </Modal>
              </>
            )}
            {!isEmpty(laws) &&
              !isEmpty(lawDocuments) &&
              !isEmpty(selectedLaw) && (
                <LawDetails
                  key={selectedDocument?._id}
                  law={selectedDocument}
                  setSelectedDocument={setSelectedDocument}
                  deleted={deleted}
                  setDeleted={setDeleted}
                />
              )}
          </div>
        </>
      )}
    </div>
  );
};

const validateRequired = value => !!value.length;

export default Editor;
